import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

import { VersionDatatable } from "src/core/components/folder/footer/VersionDatatable";
import { versionsColumns } from "src/core/components/folder/footer/versionsColumns";
import { Button } from "src/core/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "src/core/components/ui/dialog";
import { FolderFile } from "src/core/gql/graphql";
import { useRequiredTenantPaths } from "src/core/hooks/routing/useTenantPaths";
import { withRequiredOverride } from "src/core/overrides";

const FolderCardRisk = withRequiredOverride("components.folder.version.FolderCardRisk");

type VersionsModalProps = {
  open: boolean;
  setOpen: (open: boolean) => void;
  currentVersion: FolderFile | undefined;
  archivedVersions: FolderFile[];
};

export const VersionsModal: React.FC<VersionsModalProps> = ({
  open,
  setOpen,
  currentVersion,
  archivedVersions,
}) => {
  const { t } = useTranslation();
  const paths = useRequiredTenantPaths();
  const navigate = useNavigate();

  const handleNavigate = (id: string) => {
    if (!id) return;

    navigate(paths.folder(id));
    setOpen(false);
  };

  const columns = versionsColumns({ t, onNavigate: handleNavigate });

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogContent hideCloseButton>
        <DialogHeader>
          <DialogTitle>{t("folder.versions.title")}</DialogTitle>
        </DialogHeader>
        <DialogDescription className="sr-only">
          {t("folder.versions.description")}
        </DialogDescription>
        {currentVersion && (
          <div className="flex flex-col mb-20">
            <div className="uppercase font-medium h-30">{t("folder.versions.currentVersion")}</div>
            <FolderCardRisk folderFile={currentVersion} />
          </div>
        )}
        {archivedVersions && (
          <>
            <div className="uppercase font-medium h-30">
              {t("folder.versions.archivedVersions")}
            </div>
            <VersionDatatable columns={columns} data={archivedVersions} />
          </>
        )}
        <DialogFooter className="flex justify-center">
          <Button onClick={() => setOpen(false)}>{t("global.form.close")}</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
